import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import { ModalProvider } from '../../helpers/ModalContext'
import { useModal } from '../Modal'
import editIcon from '../../assets/icons/icn_edit-b.svg'
import closeIcon from '../../assets/icons/icn-close.svg'

import styles from './Card.module.scss'

interface IProps {
  title?: string
  children: React.ReactNode
  description?: string
  value?: string
  errorMessage?: string
  discoverMoreTitle?: string
  discoverMore?: React.ReactNode
  hideContent?: boolean
  onClose?: () => void
  onEdit?: () => void
  onContentOpen?: () => void
  bigTitle?: boolean
  warningMessage?: string
}

export const Card = ({
                       title,
                       description,
                       value,
                       discoverMore,
                       warningMessage,
                       discoverMoreTitle,
                       onContentOpen,
                       hideContent,
                       onEdit,
                       onClose,
                       children,
                       bigTitle,
                     }: IProps) => {
  const { Modal, openModal } = useModal()

  const openContent = () => {
    onContentOpen && onContentOpen()
  }

  return (
    <ModalProvider>
      <div className={`${styles.Wrapper} ${(hideContent || onClose) && styles.Flex}`}>
        <div>
          {title &&
          <h3 className={`${styles.Title} ${bigTitle && styles.Big}`}>
              <FormattedMessage id={title}/>
          </h3>
          }
          {description &&
          <div className={`${styles.Description} ${warningMessage && hideContent && styles.Warning}`}>
              <FormattedMessage id={!hideContent ||
              !value ?
                warningMessage && hideContent ?
                  warningMessage :
                  description :
                value}
              />
          </div>
          }
          {onClose && <>{children}</>}
        </div>
        <div className={styles.BtnWrapper}>
          {(hideContent) &&
          <button className={styles.OpenBtn} onClick={onEdit ? onEdit : openContent}>
              <img src={editIcon} alt={'edit'}/>
          </button>
          }
          {onClose &&
          <button className={styles.CloseBtn} onClick={onClose}>
              <img src={closeIcon} alt={'close'}/>
          </button>
          }
        </div>
        {!hideContent &&
        <>
          {discoverMore &&
          <button className={styles.DiscoverButton} onClick={openModal}><FormattedMessage id="discoverMore"/></button>
          }
          {children}
        </>
        }
      </div>
      {discoverMoreTitle &&
      <Modal title={discoverMoreTitle} staticContent>
        {discoverMore}
      </Modal>
      }
    </ModalProvider>
  )
}
